/**
 * Timestamp related helper functions
 */
import moment from 'moment'


export function humanReadableDate(timestamp) {
    return moment(timestamp).format('MMMM Do, YYYY')
}


export function humanReadableAppointmentTime(start, end) {
    return moment(start).format('HH:mm') + " - " + moment(end).format('HH:mm')
}

export function humanReadableAppointmentDateTime(start, end) {
    return humanReadableDate(start) + ' ' + moment(start).format('HH:mm') + " - " + moment(end).format('HH:mm')
}

export function getTimestampFromDate(date) {
    return moment(date, 'YYYY-MM-DD').toISOString()
}

/**
 * Converts DD-MM-YYYY formatted date string to YYYY-MM-DD formatted date string
 */
export function fromDayMonthYearToReverse(date) {
    return moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD')
}

/**
 * Converts YYYY-MM-DD formatted date string to DD-MM-YYYY formatted date string
 */
export function fromYearMonthDayToReverse(date) {
    return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')
}